const en = {
  meta: { code: "en", label: "English" },
  nav: {
    brand: "IQ Log",
    diagnostics: "Diagnostics",
    mypage: "My Page",
    login: "Log in",
    register: "Sign up",
    logout: "Log out",
  },
  hero: {
    eyebrow: "Diagnostic platform",
    title: "Discover your essence through diagnostics",
    subtitle1: "Thinking, personality, and aptitude — fully visualized",
    subtitle2: "See your strengths & weaknesses in 5 minutes",
    subtitle3: "Every diagnostic becomes your data",
    cta_primary: "Start a diagnostic",
    cta_secondary: "Browse catalog",
    disclaimer: "Reference info / Non-medical",
  },
  categories: {
    ability: "Ability",
    personality: "Personality",
    mental: "Mental",
    aptitude: "Aptitude",
    traits: "Traits",
  },
  catalog: {
    title: "All Diagnostics",
    subtitle: "17 tests / 5 categories",
    filter_all: "All",
    duration: "min",
    difficulty: { easy: "Easy", medium: "Medium", hard: "Hard" },
    question_count: "Qs",
    start: "Start",
  },
  quiz: {
    question: "Question",
    of: "/",
    next: "Next",
    prev: "Back",
    submit: "See result",
    progress: "Progress",
    exit: "Exit",
    required: "Please select an option",
    submitting: "Scoring…",
  },
  result: {
    overall: "Overall score",
    type_label: "Type",
    share_link: "Share this result with a link",
    back_to_catalog: "Take another diagnostic",
    view_mypage: "View history on My Page",
    premium_title: "Unlock detailed analysis",
    premium_subtitle: "With premium, you'll see everything below:",
    feature_breakdown: "Detailed score breakdown",
    feature_cause: "Root-cause analysis",
    feature_plan: "Improvement plan",
    feature_pdf: "PDF report (A4)",
    price: "¥980",
    price_note: "(Secure checkout via Stripe)",
    price_free: "Free",
    price_free_note: "(Limited time · 100% free)",
    unlock_button: "Pay with Stripe",
    unlock_button_free: "Unlock for free",
    unlock_requires_auth: "Please sign in to unlock",
    unlock_save_first: "Save your result with an account first",
    unlocking: "Redirecting to Stripe…",
    free_only_notice: "The free tier shows only overall score and type.",
    compliance_note:
      "This diagnostic provides reference information only and is not a medical diagnosis. We avoid definitive or fear-mongering language.",
  },
  premium: {
    title: "Detailed analysis report",
    summary: "Overall summary",
    strengths: "Strengths",
    weaknesses: "Growth areas",
    improvements: "Improvement plan",
    dimensions: "Dimension scores",
    download_pdf: "Download PDF",
    pdf_soon: "PDF export (coming soon)",
  },
  mypage: {
    title: "My Page",
    subtitle: "Your history, score trends, and badges",
    total: "Total diagnostics",
    average: "Average score",
    premium_count: "Unlocked",
    categories_covered: "Categories covered",
    trend_title: "Score trend",
    history_title: "History",
    badges_title: "Badges",
    unlock_3_title: "Unlock Composite Analysis",
    unlock_3_desc: "Take {n} more diagnostic(s) to unlock your composite analysis",
    unlocked: "Composite analysis unlocked",
    no_history: "No diagnostics yet — take your first one now.",
  },
  auth: {
    login_title: "Log in",
    register_title: "Create account",
    email: "Email",
    password: "Password (min 6 chars)",
    name: "Display name (optional)",
    login_btn: "Log in",
    register_btn: "Sign up",
    go_register: "Don't have an account? Sign up",
    go_login: "Already have an account? Log in",
    anon_note: "Diagnostics are free and anonymous. Account is only needed to save results and unlock premium.",
    success_register: "Account created",
    success_login: "Signed in",
    consent_section: "Consent",
    consent_required: "Please accept the required items",
    accept_terms_pre: "I agree to the",
    terms_link: "Terms of Service",
    accept_terms_post: "",
    accept_privacy_pre: "I have read the",
    privacy_link: "Privacy Policy",
    accept_privacy_post: "and consent to the processing of my personal data",
    accept_age: "I am 16 or older (or have my legal guardian's consent)",
    accept_marketing: "Send me emails about new diagnostics and promotions",
    optional: "optional",
  },
  landing: {
    status_online: "SYSTEM ONLINE",
    status_subtitle: "DIAGNOSTIC OS v2.0",
    status_tests: "17 TESTS",
    status_langs: "14 LANGS",
    status_ai: "AI · ON",
    title_line1: "Discover your essence",
    title_line2: "in 5 minutes.",
    trust_diagnostics: "DIAGNOSTICS",
    trust_languages: "LANGUAGES",
    trust_per_test: "PER TEST",
    hud_readout: "PRIMARY READOUT",
    hud_score_unit: "/100 OVERALL",
    hud_band: "BAND · GOLD",
    hud_dimensions: "DIMENSIONS",
    hud_dimensions_status: "3 / 3 LIVE",
    hud_syslog: "SYS.LOG",
    cat_eyebrow: "// CATEGORIES",
    cat_title_pre: "5 categories · ",
    cat_title_highlight: "17 diagnostics",
    view_all: "View all",
    proto_eyebrow: "// PROTOCOL",
    proto_title_pre: "Unlock your essence ",
    proto_title_highlight: "in 3 steps.",
    step1_title: "Pick a test",
    step1_body: "Choose from 17 tests. Anonymous start.",
    step2_title: "Answer in 5 min",
    step2_body: "Progress bar + badges keep you going.",
    step3_title: "Unlock by AI",
    step3_body: "Detailed score, plan & PDF.",
    final_eyebrow: "// READY?",
    final_title_pre: "Your essence ",
    final_title_highlight: "in 5 min.",
    final_subtitle: "See your strengths & weaknesses in 5 minutes",
    final_button: "Start a diagnostic now",
  },
  footer: {
    tagline: "A diagnostic platform for your thinking, personality, and aptitude",
    rights: "All rights reserved.",
    legal: "Legal",
    privacy: "Privacy",
    terms: "Terms",
    about_label: "About / Company",
    compliance_label: "International Compliance",
    tokushoho_label: "Tokushoho (Japan)",
    data_protection_label: "Data Protection (International)",
    data_request_label: "Data Deletion / Opt-out",
    disclaimer_label: "Disclaimer",
    disclaimer_full:
      "This service is for reference only and is not a medical diagnosis. We do not use definitive or fear-mongering language.",
  },
  badges: {
    "first-diagnosis": "First Diagnostic",
    "three-diagnostics": "3 Diagnostics",
    "five-diagnostics": "5 Diagnostics",
    "ten-diagnostics": "10 Diagnostics",
    "high-performer": "High Performer",
    "premium-user": "Premium User",
  },
  lang_selector: "Language",
  payment: {
    processing_title: "Verifying payment…",
    processing_subtitle: "Returned from Stripe — generating your detailed analysis (up to 20s)",
    success: "Payment confirmed — premium unlocked",
    expired: "Checkout session expired. Please try again.",
    error: "Could not verify payment. Please contact support.",
  },
};

export default en;
